import { FormattedMessage } from 'react-intl';
import PageHeaderTitleWithButtons from 'components/PageHeader/PageHeaderTitleWithButtons';
import {
  StyledPageHeaderTitle,
  StyledPageHeaderWrapper
} from 'pages/AuthorizePaymentPage/styled';
import {
  updateActiveAuthorizePaymentPage,
  updateRecordsToRetry
} from 'pages/VendorPaymentResultPage/slice';
import { clearSelectedInvoices } from 'pages/VendorsTablePage/components/VendorsTable/slice';
import { VendorsTableDataResult } from 'pages/VendorsTablePage/components/VendorsTable/types';
import { useVendorsTableData } from 'pages/VendorsTablePage/components/VendorsTable/useVendorsTableData';
import { useAppDispatch } from 'store/hooks';

export const PaymentResultHeader = ({
  paymentDate
}: {
  paymentDate: string;
}): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const { refetch }: VendorsTableDataResult = useVendorsTableData(true);
  return (
    <StyledPageHeaderWrapper data-testid="page-header">
      <StyledPageHeaderTitle>
        <FormattedMessage
          defaultMessage="Credit Card Payment - {paymentDate}"
          description="payment result page header"
          values={{ paymentDate }}
        />
      </StyledPageHeaderTitle>
      <PageHeaderTitleWithButtons
        buttons={{
          primary: {
            id: 'btn-payment-result-done',
            onClick: () => {
              dispatch(updateRecordsToRetry([]));
              dispatch(clearSelectedInvoices());
              dispatch(updateActiveAuthorizePaymentPage(''));
              refetch();
            },
            text: (
              <FormattedMessage
                defaultMessage="Done"
                description="payment result done"
              />
            )
          }
        }}
        data-testid="page-header-title-with-buttons"
      />
    </StyledPageHeaderWrapper>
  );
};
